import { cva } from 'class-variance-authority'

import { Sentiment } from '@/components/lemmala-design-system/variance-percentage/types'

// Single source of truth for all chart colors
export const CHART_COLORS = {
  // Chart tooltip colors
  teal: 'var(--chart-teal)',
  teal10: 'var(--chart-teal-10)',
  blue: 'var(--chart-sky)',
  purple: 'var(--chart-violet)',
  pink: 'var(--chart-pink)',
  emerald: 'var(--chart-emerald)',
  zinc: 'var(--palette-zinc-200)',
  neutral: 'var(--chart-zinc)',
  accent: 'var(--foreground-accent)',
  violet: 'var(--chart-violet-50)',
  gray10: 'var(--chart-zinc-10)',
  // Risk level colors
  critical: 'var(--chart-critical)',
  high: 'var(--chart-high)',
  medium: 'var(--chart-medium)',
  low: 'var(--chart-low)',
  // Outcome colors
  positive: 'var(--chart-positive)',
  negative: 'var(--chart-negative)',
  // Progress states
  success: 'var(--background-success)',
  attention: 'var(--background-attention)',
  // absence — the neutral Swatch falls back to
  unscored: 'var(--chart-unscored)',
  // fallback color
  none: 'transparent',
} as const

// No red, orange or amber, so a nominal chart can't be read as a severity chart.
export const CHART_CATEGORICAL_COLORS = [
  CHART_COLORS.accent,
  CHART_COLORS.teal,
  CHART_COLORS.purple,
  CHART_COLORS.blue,
  CHART_COLORS.pink,
  CHART_COLORS.emerald,
]

export type ChartTooltipColor = keyof typeof CHART_COLORS

// Reverse mapping for converting CSS variables back to semantic names
export const CHART_COLORS_REVERSE: Record<string, ChartTooltipColor> = Object.entries(
  CHART_COLORS,
).reduce(
  (acc, [key, value]) => {
    acc[value] = key as ChartTooltipColor
    return acc
  },
  {} as Record<string, ChartTooltipColor>,
)

// Chart tooltip color variants - uses the single source of truth
export const chartTooltipColorVariant = cva('', {
  variants: {
    color: CHART_COLORS,
  },
})

export const badgeSentimentVariant = cva(
  'text-md flex w-fit items-center gap-1 whitespace-nowrap border-none font-normal',
  {
    variants: {
      sentiment: {
        [Sentiment.NEGATIVE]: 'rounded bg-red-50 px-1 font-medium text-red-500',
        [Sentiment.POSITIVE]: 'rounded bg-green-50 px-1 font-medium text-green-500',
        [Sentiment.NEUTRAL]: 'pl-1 pr-0 text-gray-700',
      },
    },
  },
)
